export default {
  sportsbook: "Sportsbook Agent",
  login_page: "Sportsbook Agent Site",
  first_time_page: "First Time login",
  security_page: "Security Authentication",
  account_settings: "Account Settings",
  new_login: "New Login",
  two_step_verification: "Two-Step Verification",
  account_information: "Account Information",
  commission_settings: "Commission Settings",
  bet_limit_settings: "Bet Limit Settings",
  position_taking_settings: "Position Taking Settings",
  update_profile: "Update Profile",
  update_password: "Update Password",
  update_security: "Update Security",
  account_profile: "Account Profile",
  account_creation: "Account Creation",
  profile_settings: "Profile Settings",

  otp_page: "OTP Page",
  unbind_otp_2fa: "Unbind OTP 2FA",
};